module.exports = __webpack_public_path__ + "static/media/a3.86bc5275.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ArcadeRoyale/a3.jpg
// module id = 163
// module chunks = 0